const main = require('client_core/main');

main.baseFiles.customer = require('./checkout/customer.js');

main.baseFiles.dropdownWidget = require('./components/global/dropdown');
main.baseFiles.rolexV7Menu = require('./components/rolexV7Menu');
main.baseFiles.rolexV7ContactUsMessage = require('./components/rolexV7ContactUsMessage');
main.baseFiles.rolexPLPGrid = require('./components/global/plpGrid').init;
main.baseFiles.pdCarousel = require('./components/global/carousel').init;
main.baseFiles.productCarousel = require('./components/global/productCarousel').init;
main.baseFiles.rolexV7FormstackForm = require('./components/rolexV7FormstackForm');
main.baseFiles.image360Modal = require('./components/global/image360Modal').init;


module.exports = main;
